import { SupplyInstructionOptions, LabelSupplyInstructionOption } from '@caresend/types';
import { hasTypeOfSupplyInstructionSingleCheck, objToKeyValueArray } from '@caresend/utils';
import { getStore } from '../../store/helpers/initStore.js';
import '../../store/modules/app/model.js';

/**
 * Gets supply instructions as an array of strings, except centrifuge, which is
 * always excluded when displaying samples to clinician.
 */
const getSupplyInstructionsLabels = (supplyInstructions) => {
    const supplyInstructionsLabels = [];
    supplyInstructions === null || supplyInstructions === void 0 ? void 0 : supplyInstructions.forEach((items) => {
        const supplyInstructionsKeyVal = objToKeyValueArray(items);
        supplyInstructionsKeyVal.forEach(({ key: supplyOption, value: hasInstruction }) => {
            if (hasInstruction && supplyOption !== SupplyInstructionOptions.CENTRIFUGE) {
                supplyInstructionsLabels.push(LabelSupplyInstructionOption[supplyOption]);
            }
        });
    });
    return supplyInstructionsLabels;
};
/**
 * Given a procedure, build a list of type `SupplyToCheck`. Processing options
 * may be passed to filter.
 *
 * Pass `from: 'samples'` if the list of supplies to start with should be based
 * on sorted samples (lab supplies)
 *
 * Pass `filterBehaviour: 'includeOnlyFiltered'` to flip the default filtering
 * behaviour and instead include only supplies that match the filter(s).
 */
const initSuppliesToCheck = (procedure, extendedSamples, supplyInstructionOptionsToFilter = [], from = 'supplyInstructions', filterBehaviour = 'excludeFiltered') => {
    var _a, _b;
    const store = getStore();
    if (!procedure)
        return [];
    let supplyInstructions;
    if (from === 'supplyInstructions') {
        supplyInstructions = Object.values((_b = (_a = procedure === null || procedure === void 0 ? void 0 : procedure.supplyInstructionConfig) === null || _a === void 0 ? void 0 : _a.supplyInstructions) !== null && _b !== void 0 ? _b : {});
    }
    else {
        supplyInstructions = extendedSamples.map((sample) => ({
            ...sample,
            instructions: [sample.processing],
            quantity: 1,
        }));
    }
    const suppliesToCheck = supplyInstructions.reduce((currentSuppliesToCheck, item) => {
        const supply = store.getters['variables/getSupplyByID'](item.supplyID);
        const isSupplyFilteredOut = supplyInstructionOptionsToFilter.some((instructionFilter) => {
            const supplyHasInstruction = hasTypeOfSupplyInstructionSingleCheck(item, instructionFilter);
            if (filterBehaviour === 'includeOnlyFiltered')
                return !supplyHasInstruction;
            return supplyHasInstruction;
        });
        if (!supply || isSupplyFilteredOut)
            return currentSuppliesToCheck;
        const { color, id, imageColor, name } = supply;
        const addedSuppliesToCheck = Array.from(Array(item.quantity).keys()).map(() => {
            const instructions = getSupplyInstructionsLabels(item.instructions);
            return {
                color,
                imageColor,
                instructions,
                isChecked: false,
                name,
                supplyID: id,
            };
        });
        return [...currentSuppliesToCheck, ...addedSuppliesToCheck];
    }, []);
    return suppliesToCheck;
};

export { getSupplyInstructionsLabels, initSuppliesToCheck };
